import {Grid} from '@mui/material';
import {ReactElement} from 'react';
import AurIconButton from '../../../common/aur-button/AurIconButton';
import AurIcon, {IconNames, IconColors} from '../../../common/aur-icon/AurIcon';
import AurTooltip from '../../../common/aur-tooltip/AurTooltip';

interface ISTRIconButton {
  toolTipTitle: string;
  iconName: IconNames;
  iconColor: IconColors;
  customClassName?: string;
  disabled: boolean;
  onClick: () => void;
  dataTestId: string;
}

const STRIconButton = (props: ISTRIconButton): ReactElement => {
  const {
    toolTipTitle,
    iconName,
    iconColor,
    customClassName,
    disabled,
    onClick,
    dataTestId,
  } = props;

  return (
    <AurTooltip
      title={toolTipTitle}
      aria-label={toolTipTitle}
      className="tooltip-content-str typo-text label3_size"
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [7, -12],
              },
            },
          ],
        },
      }}
      disableInteractive
      disableFocusListener
    >
      <Grid item>
        <AurIconButton
          icon={
            <AurIcon
              icon={iconName}
              color={iconColor}
              customClassName={customClassName}
            />
          }
          disabled={disabled}
          onClick={onClick}
          shape
          dataTestId={dataTestId}
          ariaLabel={toolTipTitle}
        />
      </Grid>
    </AurTooltip>
  );
};

export default STRIconButton;
